import Header from "../../Components/Header";
import Hero from "../../Components/Hero";
import About from "../../Components/About";
import Skills from "../../Components/Skills";
import Portifolio from "../../Components/Portifolio";
import Curriculo from "../../Components/Curriculo";
import Footer from "../../Components/Footer";


export default function Home() {

  return (
    <div className="home">
      <Header id='header' />
      <Hero id="hero" />
      <About id="about" />
      {/* <Services id="services"/> */}
      <Skills id="skills" />
      <Portifolio id="portifolio" />
      <Curriculo id="curriculo" />
      <Footer id="contact" />
    </div>
  );
}
